import "./WorkCartStyles.css";
import WorkCart from "./WorkCart";
import WorkCardData from "./WorkCardData"


import React from 'react';
const Work = () => {
  return (
    <div className='work-container'>
        <h1 className='project-heading'>PROJECTS</h1>
        <div className='project-container'>
            {
                 WorkCardData.map((ProjectCardData, id) => {
                    return <WorkCart key={id} {...ProjectCardData} />
                })                     
                
               
            //    {
            //     WorkCardData.map((val, ind) => {
                    
            //         return(
            //             <WorkCart
                
            //             key={ind}
            //             imgsrc={val.imgsrc}
            //             title={val.title}
            //             text={val.text}
            //             view={val.view}
            //             />
            //         )
            //    }

                    // {const { imgsrc, title, text, view} = val;
            
                    // return(
                    //     <WorkCart
                
                    //     // key={ind}
                    //     imgsrc={imgsrc}
                    //     title={title}
                    //     text={text}
                    //     view={view}}
                // })
            }
        </div>      
    </div>
  )
}

export default Work
